import { Button } from "@/components/ui/button"
import { Dialog, DialogTrigger, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog"
import { PlayCircle } from "lucide-react"
import { NavLink } from "react-router-dom"

function TaskCardModal({
  title,
  description,
  sections,
  link
} : { 
  title: string, 
  description: string, 
  sections: {
    title?: string,
    paragraphsTop?: string[],
    paragraphsBottom?: string[],
    videoUrl?: string,
  }[],
  link?: string
}) {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button 
          variant="outline" 
          size="sm" 
          className="text-xs flex items-center gap-1"
        >
          <PlayCircle className="size-3" />
          Watch Tutorial
        </Button>
      </DialogTrigger>
      
      <DialogContent className="max-w-4xl max-h-[90vh] p-0 flex flex-col">
        <DialogHeader className="px-6 pt-6 pb-4 border-b">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        <div className="flex-1 overflow-y-auto px-6 py-4">
          {sections.map((section: {
            title?: string,
            paragraphsTop?: string[],
            paragraphsBottom?: string[],
            videoUrl?: string,
          }, index: number) => (
            <div key={index} className="py-4">
              {section.title && <h3 className=" font-semibold text-muted-foreground mb-1">{section.title}</h3>}
              {section.paragraphsTop && section.paragraphsTop.map((paragraph: string, index: number) => ( <p key={index} className="text-sm text-muted-foreground">{paragraph}</p> ))}
              {section.videoUrl && (
                <div className="relative w-full aspect-video bg-gray-100 dark:bg-gray-800 rounded-lg overflow-hidden my-6">
                  <iframe
                    src={section.videoUrl}
                    className="absolute top-0 left-0 w-full h-full"
                    frameBorder="0"
                    allowFullScreen
                    title={`Tutorial: ${title}`}
                  />
                </div>
              )}
              {section.paragraphsBottom && section.paragraphsBottom.map((paragraph: string, index: number) => (
                <p key={index} className="text-sm text-muted-foreground">{paragraph}</p>
              ))}
            </div>
          ))}
        </div>

        {link && (
          <div className="px-6 py-4 border-t">
            <NavLink to={link}> 
              <Button 
                variant="outline" 
                className="w-fit"
              >
                Go Setup
              </Button>
            </NavLink>
            
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default TaskCardModal